import { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import Stat from "components/common/Stat";
import { statsData } from "constant";
import Image from "next/image";
import withWindowDimensions from "components/shared/withWindowDimensions";
import { imageBasePath } from "lib/utils/imageUtils";
import { regexExpressions } from "lib/utils/regexExpressions";

export default withWindowDimensions(({ mapBannerText, isMobileSized }) => {
  const [isActive, setIsActive] = useState(false);
  const mapBannerParts = mapBannerText?.split(regexExpressions.seasons);
  return (
    <div className="max-w-[1366px] md:mx-4 xl:mx-auto md:my-24 my-12 mx-4 md:py-8 md:px-4 py-4 px-0 shadow-[3px_3px_99px_#5a60a847] rounded-[20px] flex items-center flex-col md:flex-row">
      <div className="px-4 w-full">
        <p className="text-22 md:text-5xl text-blue-950 font-bold pt-4">
          Study in your dream college with Leap
        </p>
        <div className="pt-2 md:pt-6 pb-8 md:pb-12 flex">
          <div className="w-full">
            <VisibilitySensor
              onChange={(isVisible) => setIsActive(isVisible)}
              active={!isActive}
              partialVisibility={true}
              minTopValue={80}
            >
              {({ isVisible }) => {
                return (
                  <div className="flex justify-between h-full">
                    {statsData.map((stat) => (
                      <div key={stat.id} className="w-1/3">
                        <Stat {...stat} isVisible={isVisible} key={stat.id} />
                      </div>
                    ))}
                  </div>
                );
              }}
            </VisibilitySensor>
          </div>
          {!isMobileSized && (
            <div className="mt-8 mx-4">
              <Image
                width={795}
                height={377}
                src={`${imageBasePath}/assets/images/new-landing-page/map.svg`}
                alt="world map"
                className="max-w-full h-auto"
              />
            </div>
          )}
        </div>
        <p className="text-sm md:text-lg text-gray2-600 text-center md:text-left">
          {mapBannerText ? (
            <>
              {mapBannerParts?.map((part, index) =>
                regexExpressions.seasons.test(part) ? (
                  <strong
                    key={`map-banner-text-${index}`}
                    className="text-green-400"
                  >
                    {part}
                  </strong>
                ) : (
                  part
                )
              )}
            </>
          ) : (
            <>Funded 3000+ students since inception, we're here to help you.</>
          )}
        </p>
      </div>
      {isMobileSized && (
        <div className="mt-8 mx-4">
          <Image
            width={600}
            height={300}
            src={`${imageBasePath}/assets/images/new-landing-page/map.svg`}
            alt="world map"
            className="max-w-full h-auto"
          />
        </div>
      )}
    </div>
  );
});
